import { get } from '../utils/request';

export class ControlApi {
    // 获取国家列表
    country = (data: {
        lang?: string; // 语言
    }) => get('/v2/control/country', data);

    // 获取省份列表
    province = (data: {
        lang?: string; // 语言
        country_id: string; // 国家id
    }) => get('/v2/control/province', data);

    // 获取省份详情
    provinceDetail = (data: {
        province_id: string; // 省id
    }) => get('/v2/control/provinceDetail', data);

    // 获取城市列表
    city = (data: {
        lang?: string; // 语言
        province_id: string; // 省id
    }) => get('/v2/control/city', data);

    // 获取城市详情
    cityDetail = (data: {
        city_id: string; // 省id
    }) => get('/v2/control/cityDetail', data);

    // 获取民族列表（Node 代理实现在 app/handler.v2/common/ethnicity.ts）
    ethnicity = (data?: {
        country_key?: string; // 国家key，默认中国大陆 CN_MAINLAND_KEY
    }) => get('/v2/common/ethnicity', data);
}

export default new ControlApi();
